import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  PurchaseOrderByCandidateId,
  PurchaseOrderByVendorId,
} from "../../../Redux/action/PurchaseOrderAction";
import { useLocation, useNavigate } from "react-router-dom";
import Pagination from "../../Common/Pagination/Pagination";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import { BsCheckCircleFill, BsXCircleFill } from "react-icons/bs";
import { AiOutlineClockCircle } from "react-icons/ai";

const VendorPurchase = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate(); //
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const active = query.get("active");
  const [search, setSearch] = useState("");
  const [pageNumber, setPageNumber] = useState(0);
  const [size, setSize] = useState(10);
  // const [purchaseOrderType, setPurchaseOrderType] = useState('CLIENT_ORDER');
  const vendorId = localStorage.getItem("vendorid");
  const candidateId = localStorage.getItem("userid");

  const [activeTab, setActiveTab] = useState(active ?? "CLIENT_ORDER");

  useEffect(() => {
    if (vendorId != null) {
      dispatch(
        PurchaseOrderByVendorId(search, pageNumber, size, activeTab, vendorId)
      );
      return;
    }

    if (candidateId != null) {
      dispatch(
        PurchaseOrderByCandidateId(search, pageNumber, size, candidateId)
      );
    }
  }, [activeTab, pageNumber, search, vendorId, candidateId]);


  const purchase_list = useSelector(
    (state) => state?.PurchaseOrderDetails?.result?.content
  );
  const totalPages = useSelector(
    (state) => state?.PurchaseOrderDetails?.result?.totalPages
  );

  function handlePageChange(page) {
    setPageNumber(page);
  }

  return (
    //   !isNaN(Number(localStorage.getItem('candidateVendorId'))) || !isNaN(Number(localStorage.getItem('vendorid')))
    <div className="purchase-container">
      {(!isNaN(Number(localStorage.getItem("vendorid"))) ||
        !isNaN(Number(localStorage.getItem("candidateVendorId")))) && (
        <div
          className="common_wrapper mb-4 d-flex justify-content-between align-items-center"
          style={{
            fontSize: "14px",
            width: "85%",
            backgroundColor: "white",
            marginTop: 20,
          }}
        >
          <ul className="nav nav-pills justify-content-start">
            <li className="nav-item">
              <Link to={`/purchase-details?active=CLIENT_ORDER`}>
                <button
                  className={`nav-link ${
                    activeTab === "CLIENT_ORDER"
                      ? "active bg_primary color_white"
                      : ""
                  }`}
                  onClick={() => setActiveTab("CLIENT_ORDER")}
                >
                  {" "}
                  Hire Resource{" "}
                </button>
              </Link>
            </li>
            <li className="nav-item">
              <Link to={`/purchase-details?active=SUPPLIER_ORDER`}>
                <button
                  className={`nav-link  ${
                    activeTab === "SUPPLIER_ORDER"
                      ? "active bg_primary color_white"
                      : ""
                  }`}
                  onClick={() => setActiveTab("SUPPLIER_ORDER")}
                >
                  {" "}
                  Provide Resource{" "}
                </button>
              </Link>
            </li>
          </ul>
        </div>
      )}

      <div
        style={{ width: "85%", margin: "0px auto" }}
        className="mt-3 common_shadow"
      >
        <div>
          <div
            style={{ textAlign: "start", margin: "5px 20px", padding: "5px" }}
          >
            Purchase Order List
          </div>
          {/* <div className="form-outline">
                    <input
                        className="form-control"
                        type="search"
                        placeholder="Search.. by Order Id / Purchase Order Type"
                        name="search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    ></input>
                </div> */}
        </div>

        <div className="card-body">
          <div className="table-responsive">
            <table
              className="table-data"
              style={{ width: "100%", textAlign: "center", fontSize: "14px" }}
            >
              <thead>
                <tr>
                  <th className="fw_500" scope="col">
                    Candidate ID
                  </th>
                  <th className="fw_500" scope="col">
                    Order ID
                  </th>
                  <th className="fw_500" scope="col">
                    Candidate Name
                  </th>
                  <th className="fw_500" scope="col">
                    Candidate Email
                  </th>
                  <th className="fw_500" scope="col">
                    Start Date
                  </th>

                  <th className="fw_500" scope="col">
                    Duration
                  </th>

                  {/* <th className="fw_500" scope="col">
                                        working Hours
                                    </th> */}
                  <th className="fw_500" scope="col">
                    Work Type
                  </th>
                  <th className="fw_500" scope="col">
                    Acceptance Status
                  </th>
                  {/* <th className="fw_500" scope="col">
                                        Amount
                                    </th> */}

                  <th className="fw_500" scope="col">
                    Purchase Order Type
                  </th>

                  <th className="fw_500" scope="col">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {purchase_list &&
                  purchase_list?.map((item, i) => {
                    console.log("ITEM--", item);
                    return (
                      <>
                        <tr>
                          {/* <tr
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                            navigate(
                                                                `/scheduled-more-info/${item.interviewId}`
                                                            )
                                                        }
                                                        key={i}
                                                    > */}
                          <td>{item.candidateEmpId}</td>
                          <td>{item.purchaseOrderId}</td>
                          <td>{item.candidateName}</td>
                          {/* <td>{item.jobUuid}</td> */}
                          <td>{item.candidateEmail}</td>
                          <td>{item.startDate}</td>
                          {/* <td>{item.PurchaseOrderByVendorId}</td> */}
                          <td>{item.duration}</td>
                          <td>{item?.workType}</td>
                          <td>
                            <span
                              style={{
                                borderRadius: 10,
                                fontSize: "12px",
                                fontWeight: 500,
                                padding: "4px 12px",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "4px",
                                color:
                                  item?.purchaseOrderAcceptanceStatus ===
                                  "ACCEPTED"
                                    ? "#007d3b" // green
                                    : item?.purchaseOrderAcceptanceStatus ===
                                      "REJECTED"
                                    ? "#a50000" // red
                                    : "#996c00", // yellow
                                backgroundColor:
                                  item?.purchaseOrderAcceptanceStatus ===
                                  "ACCEPTED"
                                    ? "#cbffe1"
                                    : item?.purchaseOrderAcceptanceStatus ===
                                      "REJECTED"
                                    ? "#ffd6d6"
                                    : "#fff5c0",
                              }}
                            >
                              {/* Conditional icon based on status */}
                              {item.purchaseOrderAcceptanceStatus ===
                                "ACCEPTED" && <BsCheckCircleFill />}
                              {item.purchaseOrderAcceptanceStatus ===
                                "REJECTED" && <BsXCircleFill />}
                              {item.purchaseOrderAcceptanceStatus ===
                                "PENDING" && <AiOutlineClockCircle />}

                              {item.purchaseOrderAcceptanceStatus
                                .split("_")
                                .join(" ")}
                            </span>
                          </td>
                          <td>
                            {item?.purchaseOrderType?.split("_").join(" ")}
                          </td>
                          <td>
                            <FaEye
                              size={17}
                              color="#286a94"
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                navigate(
                                  `/purchase-details/details?purchaseOrderId=${item.purchaseOrderId}`
                                )
                              }
                            />
                          </td>
                          {/* </tr> */}
                        </tr>
                      </>
                    );
                  })}
              </tbody>
            </table>
            {purchase_list?.length === 0 && (
              <div className="text-center mt-5">
                <h5>No Data Available</h5>
              </div>
            )}
          </div>
        </div>
        <div>
          {purchase_list?.length >= 1 ? (
            <Pagination
              totalPages={totalPages}
              currentPage={pageNumber}
              onPageChange={handlePageChange}
            />
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
};

export default VendorPurchase;
